import { useLive } from "../live/channel";
import { LiveView } from "../live/LiveView";
import { useAccessLog } from "../log/actionLog";

/**
 * ═══ EN DIRECT ═══
 *
 * L'écran du participant, sur son téléphone. Repris du prototype (`data-p="live"`) :
 * mêmes classes, même ordre, mêmes réglages, parce que ce sont eux le contrat vendu
 * au client et que la trappe CSS libre vise ces sélecteurs.
 *
 * ⚠️ CE QUE LA V1 ÉPARPILLE SUR SIX ADRESSES TIENT ICI. Elle sert `/live`,
 * `/live/orga`, `/live/speaker`, `/live/emotions`, `/leaderboard` et
 * `/live/questions`, plus deux paramètres d'URL non documentés (`?admin` qui
 * contourne la porte « pas encore commencé », `?mode=internal` qui bascule sur un
 * flux codé en dur). Ici, il y a trois écrans : celui-ci, la salle et la régie. Ce
 * qui est affiché ne se choisit plus en tapant une adresse, la régie le décide.
 *
 * ⚠️ ET LA PORTE « PAS ENCORE COMMENCÉ » EST UN ÉTAT, PAS UNE DATE. La V1 compare
 * l'heure du navigateur à un réglage toutes les dix secondes, ce qui fait démarrer
 * le direct à des moments différents selon les téléphones et se contourne en
 * ajoutant `?admin` à l'adresse. Ici, c'est la régie qui ouvre.
 *
 * Le contenu vit dans `live/LiveView`, parce que la régie le sert aussi : elle
 * pilote en voyant exactement ce que voit la salle.
 *
 * Displayed strings are French: this is a French product.
 */
export function Live() {
  const { data: live, isPending, isError, sequenceId } = useLive();
  useAccessLog("liveAccess");

  return (
    <section className="page">
      <LiveView
        live={live}
        sequenceId={sequenceId}
        isPending={isPending}
        isError={isError}
      />
    </section>
  );
}
